import axios from 'axios';
import toast from 'react-hot-toast';
import { API_URL } from '../env';

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  timeout: 120000,
});

let lastRedirectTime = 0;
const REDIRECT_COOLDOWN_MS = 5000;

const getRequestPath = (config) => {
  const rawUrl = config?.url || '';
  if (!rawUrl) {
    return '';
  }

  try {
    // Handles both absolute and relative URLs from axios config.
    return new URL(rawUrl, window.location.origin).pathname;
  } catch {
    return rawUrl;
  }
};

const isAuthProbeRequest = (config) => getRequestPath(config) === '/api/auth/me';

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;
    const requestConfig = error?.config;

    if (response?.status === 401) {
      if (isAuthProbeRequest(requestConfig)) {
        // Logged-out auth probe should be silent; AuthContext handles it.
        return Promise.reject(error);
      }
      const path = window.location.pathname;
      if (path.startsWith('/login') || path.includes('/callback')) {
        return Promise.reject(error);
      }

      const now = Date.now();
      if (now - lastRedirectTime < REDIRECT_COOLDOWN_MS) {
        console.error('Auth redirect loop detected, blocking redirect');
        toast.error('Authentication error. Please try logging in manually.');
        return Promise.reject(error);
      }
      lastRedirectTime = now;

      window.location.href = `${API_URL}/api/auth/login?redirect_uri=${encodeURIComponent(window.location.href)}`;
      return Promise.reject(error);
    }

    if (response?.status === 502 || response?.status === 504) {
      toast.error('Authentication service temporarily unavailable.');
    } else if (response?.status >= 500) {
      toast.error('Server error. Please try again later.');
    } else if (error.message === 'Network Error' && !isAuthProbeRequest(requestConfig)) {
      toast.error('Connection lost. Please check your internet.');
    }
    return Promise.reject(error);
  }
);

export default api;
